import * as React from "react";
import { ServiceItem } from "../../calcBusterTypes";
import { groupBy } from "shared/util/common/util";
import { USDollar } from "../../util";
import { BarChart, Box, Button } from "@amzn/awsui-components-react";

const ServicesBarChart = (services: ServiceItem[]) => {
  let grouped = groupBy(services, "serviceCode");

  return (
    <BarChart
      series={Object.keys(grouped).map((key) => ({
        title: key,
        type: "bar",
        data: [
          {
            x: "Service",
            y: grouped[key]
              .map((s: ServiceItem) => s.serviceCost * 12)
              .reduce((prev: number, curr: number) => prev + curr, 0),
          },
        ],
        valueFormatter: (e: number) => USDollar.format(e),
      }))}
      xDomain={["Service"]}
      yTickFormatter={(e) => USDollar.format(e)}
      ariaLabel="Bar chart displaying ARR by service"
      height={200}
      hideFilter
      hideLegend
      detailPopoverSize={"large"}
      xTitle="Services"
      yTitle="Annual Run Rate"
      empty={
        <Box textAlign="center" color="inherit">
          <b>No data available</b>
          <Box variant="p" color="inherit">
            There is no data available
          </Box>
        </Box>
      }
      noMatch={
        <Box textAlign="center" color="inherit">
          <b>No matching data</b>
          <Box variant="p" color="inherit">
            There is no matching data to display
          </Box>
          <Button>Clear filter</Button>
        </Box>
      }
    />
  );
};

export default ServicesBarChart;
